import '@angular/localize/init';

import { bootstrapApplication } from '@angular/platform-browser';
import { loadTranslations } from '@angular/localize';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import './app/fontawesome.config';
import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
// import localeEn from '@angular/common/locales/en';


// Load default translations before bootstrapping
async function loadDefaultTranslations(): Promise<void> {
  try {
    // Try to load saved locale from localStorage
    const savedLocale = localStorage.getItem('locale') || navigator?.language || 'en-US';
    const response = await fetch(`/assets/i18n/${savedLocale}.json`);

    if (response.ok) {
      const data = await response.json();
      if (data.translations) {
        loadTranslations(data.translations);
        document.documentElement.lang = savedLocale;
        return;
      }
    }
  } catch (error) {
    console.warn('Could not load translations, using default', error);
  }

  // Fallback: load English translations
  try {
    const response = await fetch('/assets/i18n/en-US.json');
    if (response.ok) {
      const data = await response.json();
      if (data.translations) {
        loadTranslations(data.translations);
        document.documentElement.lang = 'en-US';
      }
    }
  } catch (error) {
    console.error('Failed to load default translations', error);
  }
}

registerLocaleData(localePl);
// registerLocaleData(localeEn);

// Load translations and then bootstrap
loadDefaultTranslations().then(() => {
  bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));
});
